module.exports = __webpack_public_path__ + "ms-icon-70x70.png?3c7dbcc61a4955185e82d2f4bdfa56f1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ms-icon-70x70.png
// module id = 229
// module chunks = 0